<div class="toggle-group">
    <div class="toggle-group-buttons">
        @for (option of options; track option.value) {
            @if (option.value === selectedValue) {
                <cerrix-button buttonType="primary" (click)="onOptionClick(option)"
                    >{{ option.label }}
                    @if (option.count && option.count > 0) {
                        ({{ option.count }})
                    }
                </cerrix-button>
            } @else {
                <cerrix-button
                    buttonType="secondary"
                    secondaryColor="filled"
                    (click)="onOptionClick(option)"
                    >{{ option.label }}
                    @if (option.count && option.count > 0) {
                        ({{ option.count }})
                    }
                </cerrix-button>
            }
        }
    </div>
</div>
